import UiListItem from "./UiListItem";
import MiezzListItem from "@/models/MiezzListItem";
import { EnumPipe } from "@/models/EnumPipe";
import { EnumParamAuditStatus, EnumParamAuditStatusOption } from "./EnumParamAuditStatus";

/**
 * 渠道分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class DtoListItemParamTransportChannel extends UiListItem<string> {
    constructor() {
        //无参构造函数
        super()
        this.Status = EnumParamAuditStatus.Not;
        this.IsEdit = false;
    }

    [proName: string]: any;
    /**
     * 中文名称
     */
    NameZh?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 缩写
     */
    Abridge?: string;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 备注
     */
    Remarks?: string;
    /**
     * 审核状态
     */
    Status?: EnumParamAuditStatus;
    /**
     * 是否可以编辑
     */
    IsEdit?: boolean;
    /**
     * 创建人所属公司
     */
    CreatedCompanyId?: string;
}

/**
 * 渠道分页列表-项-表单校验
 */
export const DtoListItemParamTransportChannelRules = {
}

/**
 * 渠道分页列表-项-设置项
 */
export const DtoListItemParamTransportChannelMiezzListItems: MiezzListItem[]  = [
  {
    Prop: "NameZh",
    Label: "中文名称",
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
  },
  {
    Prop: "Abridge",
    Label: "缩写",
  },
  {
    Prop: "FullName",
    Label: "全名",
  },
  {
    Prop: "Remarks",
    Label: "备注",
  },
]
